import React from "react"
import {RouteComponentProps} from "react-router"
import {useTranslation} from "react-i18next"

import {useTimeLimits as useItems} from "../../contexts/TimeLimitContext"

import ItemForm from "../../components/TimeLimits/Form"
import ItemView from "../../components/TimeLimits/View"
import TimeListDataList from "../../components/TimeLimits/TimeLimitDataList"
import NotFound from "../../components/TimeLimits/NotFound"
import PageItem from "../common/Item"
import KeysList from "../../components/TimeLimits/KeysList";
import LocksList from "../../components/TimeLimits/LocksList";

interface pageProps extends RouteComponentProps<{
    id:      string;
    segment: string;
}> {}

const PageTimeLimitsItem: React.FC<pageProps> = ({ match }) => {
    const { t }        = useTranslation()
    const { fetchItems, items} = useItems()

    const
        itemType:     string = 'TimeLimit',
        itemTypeName: string = t('time-limits.title_item'),
        itemTypeUrl:  string = 'time-limits'

    return (
        <PageItem
            useItems={useItems}
            fetchItems={fetchItems}
            itemId={match.params.id}
            items={items}
            itemType={itemType}
            itemTypeName={itemTypeName}
            itemTypeUrl={itemTypeUrl}
            ItemNotFound={NotFound}
            ItemView={ItemView}
            ItemForm={ItemForm}
            KeysList={KeysList}
            LocksList={LocksList}
            TimeLimitDataList={TimeListDataList}
            segment={match.params.segment}
        />
    )
}

export default PageTimeLimitsItem